import Cookies from "js-cookie";
import { TbRefresh } from "react-icons/tb";
import { CircularProgress } from "@mui/material";
import noDataFound from "src/assets/no-data.png";
import { MdArrowBackIosNew } from "react-icons/md";
import { useApiWithAxios } from "src/hooks/useApi";
import CONSTANTS from "src/components/services/api";
import CustomBadge from "src/components/atoms/Badge";
import ChatCard from "src/components/molecules/ChatCard";
import CustomTab from "src/components/molecules/CustomTab";
import React, { useContext, useEffect, useState } from "react";
import {
  AdminDashboardContext,
  MyContext,
} from "src/components/Context/MyContext";
import StandardSearch from "src/components/atoms/inputfields/StandardSearch";
import loaderAnimation from "src/assets/loaderAnimation.gif";
import { Box, Modal } from "@mui/material";
import { toast, Bounce } from "react-toastify";
import { HiOutlineRefresh } from "react-icons/hi";

let notFirstTime = false;
const CoachList = ({ onBack, bearerToken }) => {
  const limit = 5;
  const selectedUserId = Cookies.get("selected_user_id");
  const roleId = Cookies.get("roleId");
  const { selectedCoach, newMessageOn, setNewMessageOn } = useContext(
    AdminDashboardContext
  );
  const { socket, userId } = useContext(MyContext);
  const [query, setQuery] = useState("");
  const [startSearch, setStartSearch] = useState(false);

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    border: "1px solid #F0F0F0",
    borderRadius: "8px",
    outline: "none",
    maxWidth: "100%",
    maxHeight: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    // height: "100%",
    // width: "100%",
  };

  const [status, setStatus] = useState(1);
  const [pageNo, setPageNum] = useState(1);
  const [showLoader, setShowLoader] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isExiting, setIsExiting] = useState(false);
  const [liveAndGrace, setLiveAndGrace] = useState([]);
  const [completedData, setCompletedData] = useState([]);
  const [ratingPendingBox, setRatingPendingBox] = useState(false);
  const [ratingCardData, setRatingCardData] = useState(null);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const [changeUnreadMessageState, setChangeUnreadMessageState] =
    useState(false);
  const [liveAndGraceCountValue, setLiveAndGraceCountValue] = useState(
    data?.totalMessage?.live_total
  );
  const [completedCountValue, setCompletedCountValue] = useState(
    data?.totalMessage?.complete_total
  );
  const [resetKey, setResetKey] = useState(0);
  const [unreadMsgRefresh, setUnreadMsgRefresh] = useState(false);
  const [newMessageOnData, setNewMessageOnData] = useState(null);

  const { setSelectedChat } = useContext(MyContext);

  // before use : `${CONSTANTS.API_BASE}/coachenrollmentschecks_production?coach_id=${userId}&limit=${limit}&pageNo=${pageNo}&status=${status}&keywords=${query}`,

  // const { data, error, loading } = useApiWithAxios(
  //   `${CONSTANTS.API_BASE}/coachenrollmentschecks_web?coach_id=${
  //     userId == "1" ? selectedUserId : userId
  //   }&limit=${limit}&pageNo=${pageNo}&status=${status}&keywords=${query}`,
  //   "GET",
  //   null,
  //   {
  //     headers: {
  //       Authorization: bearerToken ? bearerToken : CONSTANTS.BearerToken,
  //     },
  //   },
  //   [status, pageNo, query, newMessageOn, refresh]
  // );

  useEffect(() => {
    // This effect runs when you want to trigger a reset, e.g., after new data or a button click.
    setResetKey((prev) => prev + 1);
  }, [newMessageOn]);

  useEffect(() => {
    if (!changeUnreadMessageState) {
      try {
        // if i want to unread every time
        // socket.emit("get-enrollment-coach", getEnrollmentPayload(changeUnreadMessageState ? 1 : 0, pageNo));
        socket.emit("get-enrollment-coach", getEnrollmentPayload(0, 1));
        socket.on("get-enrollment-coach-response", (response) => {
          const { error = null } = response;
          if (error) {
            setIsLoading(false);
            toast.error(error?.message || "Error occure in load more data", {
              position: "top-center",
              autoClose: 1000,
              transition: Bounce,
            });
            return;
          }
          setData(response);
          setNewMessageOnData(response);
          setLiveAndGraceCountValue(response?.totalMessage?.live_total);
          setCompletedCountValue(response?.totalMessage?.complete_total);
        });
      } catch (error) {
        console.log("Error in socket connection", error);
      }
    }
  }, [status, refresh, newMessageOn]);

  useEffect(() => {
    if (!startSearch) return;
    try {
      // if i want to unread every time
      // socket.emit("get-enrollment-coach", getEnrollmentPayload(changeUnreadMessageState ? 1 : 0, pageNo));
      socket.emit("get-enrollment-coach", getEnrollmentPayload(0, 1));
      socket.on("get-enrollment-coach-response", (response) => {
        const { error = null } = response;
        if (error) {
          setIsLoading(false);
          toast.error(error?.message || "Error occure in load more data", {
            position: "top-center",
            autoClose: 1000,
            transition: Bounce,
          });
          return;
        }
        setData(response);
        if(query == "") {
          setStartSearch(false);
          setPageNum(1);
        }
        saveDataAccordingToPageNum();
        if(pageNo < 1 && query != ""){
          setNewMessageOnData(response);
        }
        setLiveAndGraceCountValue(response?.totalMessage?.live_total);
        setCompletedCountValue(response?.totalMessage?.complete_total);
      });
    } catch (error) {
      console.log("Error in socket connection", error);
    }
  }, [query]);

  useEffect(() => {
    if (pageNo != 1) {
      try {
        // if i want to unread every time
        // socket.emit("get-enrollment-coach", getEnrollmentPayload(changeUnreadMessageState ? 1 : 0, pageNo));
        socket.emit("get-enrollment-coach", getEnrollmentPayload(0, pageNo));
        socket.on("get-enrollment-coach-response", (response) => {
          const { error = null } = response;
          if (error) {
            setIsLoading(false);
            toast.error(error?.message || "Error occure in load more data", {
              position: "top-center",
              autoClose: 1000,
              transition: Bounce,
            });
            return;
          }
          setData(response);
          setLiveAndGraceCountValue(response?.totalMessage?.live_total);
          setCompletedCountValue(response?.totalMessage?.complete_total);
        });
      } catch (error) {
        console.log("Error in socket connection", error);
      }
    }
  }, [pageNo]);

  // if i want to unread every time
  // useEffect(() => {
  //   if (changeUnreadMessageState) {
  //     try {
  //       setPageNum(1);
  //       socket.emit("get-enrollment-coach", getEnrollmentPayload(1, 1));
  //       socket.on("get-enrollment-coach-response", (response) => {
  //         const { error = null } = response;
  //         if (error) {
  //           setIsLoading(false);
  //           toast.error(error?.message || "Error occure in load more data", {
  //             position: "top-center",
  //             autoClose: 1000,
  //             transition: Bounce,
  //           });
  //           return;
  //         }
  //         setData(response);
  //       });
  //     } catch (error) {
  //       console.log("Error in socket connection", error);
  //     }
  //   }
  // }, [changeUnreadMessageState, pageNo]);

  useEffect(() => {
    if (changeUnreadMessageState) {
      try {
        setPageNum(1);
        socket.emit("get-enrollment-coach", getEnrollmentPayload(1, 1));
        socket.on("get-enrollment-coach-response", (response) => {
          const { error = null } = response;
          if (error) {
            setIsLoading(false);
            toast.error(error?.message || "Error occure in load more data", {
              position: "top-center",
              autoClose: 1000,
              transition: Bounce,
            });
            return;
          }
          setData(response);
          setLiveAndGraceCountValue(response?.totalMessage?.live_total);
          setCompletedCountValue(response?.totalMessage?.complete_total);
        });
      } catch (error) {
        console.log("Error in socket connection", error);
      }
    }
  }, [changeUnreadMessageState, pageNo]);

  useEffect(() => {
    if (data) {
      setIsLoading(false);
      // if i want to unread every time
      if (changeUnreadMessageState) {
        setChangeUnreadMessageState(false);
      }
      saveDataAccordingToPageNum();
    }
  }, [data]);

  useEffect(() => {
    if (
      (liveAndGrace.length == 0 && completedData.length == 0) ||
      !newMessageOnData
    ) {
      return;
    }

    if (status == 1) {
      const newArray = changedCountOfArray(
        liveAndGrace,
        newMessageOnData?.data
      );
      setLiveAndGrace(newArray);
    } else if (status == 2) {
      const newArray =
        completedData.length > 0
          ? changedCountOfArray(completedData, newMessageOnData?.data)
          : newMessageOnData?.data;
      setCompletedData(newArray);
    }
  }, [newMessageOnData]);

  useEffect(() => {
    if (isExiting) {
      const timer = setTimeout(() => {
        onBack();
      }, 300);
      return () => clearTimeout(timer);
    }
  }, [isExiting, onBack]);

  //   function changedCountOfArray(arr1, arr2) {
  //     if (arr1?.length == 0 || arr2?.length == 0) return arr1;
  //     const updatedArr1 = arr1.map((item1) => {
  //       const match = arr2.find((item2) => item2._id === item1._id);
  //       return match ? { ...item1, unreadCount: match.unreadCount } : item1;
  //     });
  //     arr2.forEach(item2 => {
  //   const exists = arr1.find(item1 => item1._id === item2._id);
  //   if (!exists) {
  //     updatedArr1.push(item2);
  //   }
  // });
  //     return updatedArr1;
  //   }

  function saveDataAccordingToPageNum(){
    if (pageNo === 1) {
        if (status === 1) {
          setLiveAndGrace(data.data);
        } else if (status === 2) {
          setCompletedData(data.data);
        }
      } else {
        if (status === 1) {
          const isAllExist = existMessage(liveAndGrace, data.data);
          if (!isAllExist) {
            setLiveAndGrace((prev) => [...prev, ...data.data]);
          }
        } else if (status === 2) {
          const isAllExist = existMessage(completedData, data.data);
          if (!isAllExist) {
            setCompletedData((prev) => [...prev, ...data.data]);
          }
        }
      }
      return ;
  }

  function changedCountOfArray(arr1, arr2) {
    if (arr1?.length == 0 || arr2?.length == 0) return arr1;
    if (changeUnreadMessageState) return arr2;
    if (!!query && pageNo == 1) return arr2;
    const matched = [];
    const unmatched = [];
    const newItems = [];

    // Loop through arr2 to find matches and new items
    arr2.forEach((item2) => {
      const matchInArr1 = arr1.find((item1) => item1._id === item2._id);
      if (matchInArr1) {
        matched.push({ ...matchInArr1, unreadCount: item2.unreadCount }); // update count
      } else {
        newItems.push(item2); // not found in arr1, so it's new
      }
    });

    // Now check arr1 for items that were not matched
    arr1.forEach((item1) => {
      const matchInArr2 = arr2.find((item2) => item2._id === item1._id);
      if (!matchInArr2) {
        unmatched.push(item1);
      }
    });

    // Combine all parts
    const updatedArr1 = [...matched, ...unmatched, ...newItems];
    return updatedArr1;
  }

  const handleSearchChange = (e) => {
    setQuery(e.target.value);
    setStartSearch(true);
    setPageNum(1);
  };

  const handleTabChange = (val) => {
    setShowLoader(true);
    if (val < 2) {
      setStatus(val + 1);
      setPageNum(1);
    }
    setTimeout(() => {
      setShowLoader(false);
    }, 100);
  };

  const handleBack = () => {
    setIsExiting(true);
  };

  function getEnrollmentPayload(unreadMsg, pageNum) {
    return {
      coach_id:
        roleId == "1" || roleId == "6" || roleId == "7"
          ? selectedUserId
          : userId,
      limit: limit,
      pageNo: pageNum,
      keywords: query,
      status: status,
      unread: unreadMsg,
    };
  }

  function existMessage(arr01, arr02) {
    const isAllExist = arr02.every((item2) =>
      arr01.some((item1) => item1._id === item2._id)
    );
    return isAllExist;
  }

  const loadMore = () => {
    notFirstTime = true;
    // if (unreadMsgRefresh) {
    //   setChangeUnreadMessageState(true);
    // }
    setIsLoading(true);
    setPageNum((prev) => prev + 1);
  };

  const TabCardList = (list) => {
    if (showLoader) {
      return (
        <div className="flex justify-center h-[55vh] items-center">
          <img src={loaderAnimation} alt="loader" />
        </div>
      );
    }

    if (showLoader == false) {
      if (list && list?.length === 0) {
        return (
          <div className="flex flex-col justify-center items-center h-[550px] text-gray-500">
            <img src={noDataFound} alt="" />
            <h1 className="font-bold text-[#475569] text-[20px] text-center">
              No results found
            </h1>
            <p className="text-[#76767CCC] font-normal text-[12px] md:w-[250px] w-[200px] text-center mt-3">
              We couldn’t find what you are searched for. Try searching again
            </p>
          </div>
        );
      }
    }

    return (
      <>
        {ratingPendingBox && showRatingBox()}
        {list?.map((client, i) => (
          <ChatCard
            key={i}
            data={client}
            setRatingPendingBox={setRatingPendingBox}
            setRatingCardData={setRatingCardData}
            setLiveAndGraceCountValue={setLiveAndGraceCountValue}
            liveAndGraceCountValue={liveAndGraceCountValue}
            setCompletedCountValue={setCompletedCountValue}
            completedCountValue={completedCountValue}
            status={status}
            resetKey={resetKey}
          />
        ))}
        {list?.length < data?.total && (
          <div className="flex justify-center items-center">
            <button
              className="bg-white px-10 py-1 flex items-center justify-center rounded-md border-[2px] border-[#FBF712]  shadow-amber-200 mt-1 text-[12px] font-medium hover:bg-[#fbf659c1] transition-colors duration-200 hover:text-black"
              onClick={loadMore}
              disabled={isLoading}
            >
              {isLoading ? (
                <CircularProgress className="!h-7 !w-7 !text-black" />
              ) : (
                "Load more"
              )}
            </button>
          </div>
        )}
      </>
    );
  };

  function showRatingBox() {
    return (
      <Modal
        open={ratingPendingBox}
        onClose={() => setRatingPendingBox(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        BackdropProps={{
          style: {
            backgroundColor: "rgba(0, 0, 0, 0.1)",
          },
        }}
      >
        <Box sx={style}>
          <div className="absolute top-[50%] border bg-white p-3 z-50 w-[325px] left-12 h-[125px]">
            <div>
              <h3 className="font-semibold">Rating Pending From User</h3>
            </div>
            <div className="flex justify-end mt-12">
              <button
                className="font-medium"
                onClick={() => setRatingPendingBox(false)}
              >
                ok
              </button>
              <button
                className="text-sm pl-12 font-medium"
                onClick={() => {
                  setSelectedChat(ratingCardData);
                  // setNewMessageOn(!newMessageOn);
                  localStorage.setItem(
                    "showChat",
                    JSON.stringify(ratingCardData)
                  );
                  localStorage.setItem("my-message", JSON.stringify([]));
                  setRatingPendingBox(false);
                }}
              >
                VIEW CHAT
              </button>
            </div>
          </div>
        </Box>
      </Modal>
    );
  }

  const tabData = [
    {
      label: (
        <CustomBadge
          badgeContent={`${liveAndGraceCountValue}`}
          label=" Live & Grace"
        />
      ),
      content: (
        <div className={`client-list ${isExiting ? "slide-out" : ""}`}>
          {TabCardList(liveAndGrace ? liveAndGrace : [])}
        </div>
      ),
    },
    {
      label: (
        <CustomBadge
          badgeContent={`${completedCountValue}`}
          label=" Completed"
        />
      ),
      content: (
        <div className={`client-list ${isExiting ? "slide-out" : ""}`}>
          {TabCardList(completedData)}
        </div>
      ),
    },
    {
      label: "Unread"
    }, 
    {
      label: <TbRefresh size={24} style={{ transform: "rotate(180deg)" }} />,
    }
    
  ];
  return (
    <div className="!mt-0 ">
      {(roleId == "1" || roleId == "6" || roleId == "7") && selectedCoach ? (
        <div
          className={`client-list   ${
            isExiting ? "slide-out" : ""
          } text-[#3497F9] flex items-center space-x-1 cursor-pointer mb-3`}
          onClick={handleBack}
        >
          <MdArrowBackIosNew size={15} />
          <span className=" font-medium text-xs">Back</span>
        </div>
      ) : null}
      <StandardSearch
        placeholder={`${
          status === 1
            ? "Search Live & Grace clients..."
            : "Search completed clients..."
        }`}
        onChange={handleSearchChange}
        value={query}
      />
      <CustomTab
        tabs={tabData}
        initialIndex={0}
        changeTab={handleTabChange}
        refresh={refresh}
        setRefresh={setRefresh}
        setChangeUnreadMessageState={setChangeUnreadMessageState}
        changeUnreadMessageState={changeUnreadMessageState}
        setUnreadMsgRefresh={setUnreadMsgRefresh}
      />
    </div>
  );
};

export default CoachList;
